import React, { useState } from "react";
import * as S from "./AdminThemeDrawer.styled";
import { adminThemeService } from "services/adminThemeService";

interface Props {
  onClose: () => void;
  onSuccess: () => void;
}

const AdminThemeDrawer: React.FC<Props> = ({ onClose, onSuccess }) => {
  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState("");

  const validate = (): boolean => {
    if (!name.trim()) {
      setNameError("테마명을 입력해주세요.");
      return false;
    }
    setNameError("");
    return true;
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    setIsSubmitting(true);
    setSubmitError("");

    try {
      const universityId = Number(localStorage.getItem("adminUniversityId"));
      await adminThemeService.create(universityId, { name: name.trim() });
      onSuccess();
    } catch {
      setSubmitError("테마 추가에 실패했습니다. 다시 시도해주세요.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <S.Overlay onClick={onClose}>
      <S.Drawer onClick={(e) => e.stopPropagation()}>

        {/* 헤더 */}
        <S.DrawerHeader>
          <S.DrawerTitle>테마 추가</S.DrawerTitle>
          <S.CloseButton onClick={onClose}>✕</S.CloseButton>
        </S.DrawerHeader>

        {/* 바디 */}
        <S.DrawerBody>
          <S.Field>
            <S.Label htmlFor="name">
              테마명 <S.Required>*</S.Required>
            </S.Label>
            <S.Input
              id="name"
              placeholder="예) 스터디룸"
              value={name}
              onChange={(e) => {
                setName(e.target.value);
                setNameError("");
              }}
              hasError={!!nameError}
            />
            {nameError && <S.FieldError>{nameError}</S.FieldError>}
          </S.Field>

          {submitError && (
            <S.FieldError style={{ textAlign: "center" }}>{submitError}</S.FieldError>
          )}
        </S.DrawerBody>

        {/* 푸터 */}
        <S.DrawerFooter>
          <S.CancelButton onClick={onClose}>취소</S.CancelButton>
          <S.SubmitButton onClick={handleSubmit} disabled={isSubmitting}>
            {isSubmitting ? "등록 중..." : "테마 추가"}
          </S.SubmitButton>
        </S.DrawerFooter>

      </S.Drawer>
    </S.Overlay>
  );
};

export default AdminThemeDrawer;
